module.exports = __webpack_public_path__ + "static/media/empty-calendar.3c470803.svg";